import { gql, TypedDocumentNode } from '@apollo/client'
import { contractDatumFragment } from './ContractDatumFragment'
import { workdayFragment } from './WorkdayFragment'
import type { ContractFragment } from './__generated__/ContractFragment'

export const contractFragment: TypedDocumentNode<ContractFragment> = gql`
  ${contractDatumFragment}
  ${workdayFragment}

  fragment ContractFragment on Contract {
    attemptsCount
    backOfficeId
    buildingNumber
    cancellationRequest {
      isApproved
      reason
      requester {
        email
        firstName
        lastName
      }
    }
    city
    contractPremiums {
      contributionValue
      id
      premium {
        id
        name
      }
      unit
      value
    }
    contractReason
    costPlace
    #    country: Country!
    #    employee: Employee!
    id
    latitude
    longitude
    parentContractId
    position {
      contractDatum {
        ...ContractDatumFragment
      }
      id
    }
    street
    streetNumber
    wage
    #    workPostSheet: WorkPostSheet
    workdays {
      ...WorkdayFragment
    }
    zip
  }
`
